




































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { Sorters } from "@/data/table";
import { ITableConfig } from "@/models/tables";
import { IEmail } from "@/models/emails";
import { IState } from "@/store";
import Context from "@/mixins/context";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "email-history-status": () =>
      import("@/components/app/global/emailHistory/emailHistoryStatus.vue")
  },
  computed: {
    ...mapState({
      clientEmail(state: IState, getters) {
        return getters[`data/${DataModules.CLIENTS}/getClientEmail`](
          this.clientId
        );
      },
      params(state: IState, getters) {
        return getters[`data/${this.dataModule}/params`](this.clientId);
      },
      selectorParams(state: IState, getters) {
        return getters[`data/${this.dataModule}/selectorParams`](this.clientId);
      },
      selectorDataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/selectorScope`](this.clientId);
      }
    })
  }
})
export default class ClientEmailsTable extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  // Getters
  public clientEmail!: IEmail;
  public params!: object;
  public selectorParams!: object;
  public selectorDataScope!: string;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: false })
  public isStaged!: boolean;

  public dataModule: string = DataModules.CLIENTS_EMAILS;

  public defaults: ITableConfig = {
    page: 1,
    limit: 0,
    sort: {
      field: "default,created_at",
      direction: Sorters.DESCENDING
    },
    filters: []
  };

  public created() {
    if (this.$userCan("list_client_emails")) {
      this.apiProps = { limit: 0 };
      this.dataPayloadSettings = { id: this.clientId };
      this.getData();
    } else {
      this.loading = false;
    }
  }

  public editEmail(email: IEmail) {
    const action = `data/${this.dataModule}/openEditModal`;
    return this.$store.dispatch(action, email);
  }

  public async markAsVerified(email: IEmail) {
    const action = `data/${this.dataModule}/markAsVerified`;
    const onSuccess: boolean = await this.$store.dispatch(action, { email });
    if (onSuccess) return this.refreshList();
  }

  public async makeDefault(email: IEmail) {
    const action = `data/${this.dataModule}/makeDefault`;
    const onSuccess: boolean = await this.$store.dispatch(action, { email });
    if (onSuccess) return this.refreshList();
  }

  public async deleteEmail(email: IEmail) {
    const action = `data/${this.dataModule}/confirmDelete`;
    this.$store.dispatch(action, {
      email,
      onConfirm: this.refreshList
    });
  }

  public async resendVerificationEmail(email: IEmail) {
    const action = `data/${this.dataModule}/resendVerificationEmail`;
    return this.$store.dispatch(action, { email });
  }

  public refreshList() {
    return this.getData({ ignoreStored: true });
  }
}
